import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import BaseFormCard from '@/views/base/BaseFormCard.vue';
import { commitAddNotification } from '@/store/main/mutations';
import { store } from '@/store/index';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';
import { InvalidFileTypeError } from '@/utils/error';


export default /*#__PURE__*/_defineComponent({
  __name: 'RiskReassessmentCsvUploadDialog',
  props: {
    value: { type: Boolean },
    isDownloadable: { type: Boolean },
    isUploadable: { type: Boolean },
    header: null,
    uploadLimitText: null,
    downloadCsvText: null
  },
  emits: ["input", "downloadCSV", "csvFileUpload"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'downloadCSV'): void;
  (e: 'csvFileUpload', file: File, hideParentModal: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  isDownloadable: boolean;
  isUploadable: boolean;
  header: string;
  uploadLimitText: string;
  downloadCsvText: string;
};

const m = defineMessages({
  helpCenterText: '※作業環境の入力項目の詳細は「{link}」をご確認ください。',
});





const model = computed({
  get: () => props.value,
  set: (value) => emit('input', value),
});

const csvFile = ref<File | null>(null);
const fileInputRef = ref<HTMLInputElement | null>(null);
const isValidFile = ref<boolean>(true);

watch(
  () => model.value,
  (newValue) => {
    if (newValue) {
      csvFile.value = null;
    }
  }
);

const closeDialog = () => {
  csvFile.value = null;
  model.value = false;
};

const handleCancelClick = () => {
  closeDialog();
};

const handleDownloadClick = () => {
  emit('downloadCSV');
};

const triggerFileInput = () => {
  if (fileInputRef.value) {
    fileInputRef.value.click();
  } else {
    commitAddNotification(store, {
      messageKey: 'CSVファイル以外アップロード不可にする。',
      color: 'error',
    });
  }
};

const handleFileUpload = (e: Event | DragEvent) => {
  try {
    const target = e.target as HTMLInputElement;
    if (e instanceof DragEvent && e.dataTransfer?.files.length) {
      csvFile.value = e.dataTransfer.files[0];
    } else if (target.files && target.files.length > 0) {
      csvFile.value = target.files[0];
    }
    if (fileInputRef.value) {
      fileInputRef.value.value = '';
    }
    if (csvFile.value) {
      isValidFile.value = true;

      if (!csvFile.value.name.toLowerCase().endsWith('.csv')) {
        throw new InvalidFileTypeError('Only CSV files are allowed');
      }
    } else {
      commitAddNotification(store, {
        messageKey: 'No file selected!',
        color: 'error',
      });
    }
  } catch (error) {
    isValidFile.value = false;

    if (fileInputRef.value) {
      fileInputRef.value.value = '';
    }

    if (error instanceof InvalidFileTypeError) {
      commitAddNotification(store, {
        messageKey:
          'CSVファイル以外アップロードできません。ファイルの拡張子が.csvであることを確認して、再度アップロードしてください。',
        color: 'error',
      });
    } else {
      commitAddNotification(store, {
        messageKey:
          'CSVファイルアップロードに失敗しました。しばらくしてから再度アップロードしてください。',
        color: 'error',
      });
    }
  }
};

const handleExecuteClick = () => {
  if (csvFile.value) {
    emit('csvFileUpload', csvFile.value, true);
  }
};

const removeCSVFile = () => {
  csvFile.value = null;
  isValidFile.value = true;
};

return { __sfc: true,m, props, emit, model, csvFile, fileInputRef, isValidFile, closeDialog, handleCancelClick, handleDownloadClick, triggerFileInput, handleFileUpload, handleExecuteClick, removeCSVFile, BaseFormCard, sharedMessages }
}

})